import { useEffect, useState } from "react";
import { AdminLayout } from "@/components/AdminLayout";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";

const empty = { title: "", description: "", area: "legislativo", category: "", professor: "", duration_minutes: 30, video_url: "", thumbnail_url: "", is_published: true };

export default function AdminCursosGratuitos() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);
  const load = () => api.get("/free-courses").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    const payload = { ...form, duration_minutes: Number(form.duration_minutes) };
    try {
      if (editId) await api.put(`/free-courses/${editId}`, payload);
      else await api.post("/free-courses", payload);
      toast.success("Salvo");
      setOpen(false); setEditId(null); setForm(empty); load();
    } catch { toast.error("Erro ao salvar"); }
  };
  const edit = (c) => { setEditId(c.id); setForm({ ...c }); setOpen(true); };
  const remove = async (id) => { if (window.confirm("Excluir curso?")) { await api.delete(`/free-courses/${id}`); load(); } };

  return (
    <AdminLayout title="Aulas Gratuitas">
      <div className="flex justify-end mb-3">
        <Button onClick={() => { setEditId(null); setForm(empty); setOpen(true); }}><Plus className="w-4 h-4 mr-1" /> Novo curso</Button>
      </div>
      <Card className="rounded-xl"><CardContent className="p-0 overflow-x-auto">
        <Table><TableHeader><TableRow>
          <TableHead>Curso</TableHead><TableHead>Área</TableHead><TableHead>Categoria</TableHead><TableHead>Duração</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Ações</TableHead>
        </TableRow></TableHeader>
          <TableBody>
            {items.map(c => (
              <TableRow key={c.id}>
                <TableCell><p className="font-medium">{c.title}</p><p className="text-xs text-muted-foreground">{c.professor}</p></TableCell>
                <TableCell><Badge variant="secondary" className="capitalize">{c.area}</Badge></TableCell>
                <TableCell>{c.category}</TableCell>
                <TableCell>{c.duration_minutes} min</TableCell>
                <TableCell>{c.is_published ? <Badge className="bg-emerald-100 text-emerald-800 border-emerald-200">Publicado</Badge> : <Badge variant="outline">Rascunho</Badge>}</TableCell>
                <TableCell className="text-right">
                  <Button variant="ghost" size="icon" onClick={() => edit(c)}><Pencil className="w-4 h-4" /></Button>
                  <Button variant="ghost" size="icon" onClick={() => remove(c.id)}><Trash2 className="w-4 h-4 text-rose-600" /></Button>
                </TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={6} className="py-10 text-center text-sm text-muted-foreground">Nenhum curso cadastrado</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent></Card>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-[600px] rounded-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader><DialogTitle>{editId ? "Editar curso" : "Novo curso gratuito"}</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <div><Label>Título</Label><Input required value={form.title} onChange={(e) => setForm(f => ({ ...f, title: e.target.value }))} /></div>
            <div><Label>Descrição</Label><Textarea rows={3} value={form.description} onChange={(e) => setForm(f => ({ ...f, description: e.target.value }))} /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label>Área</Label>
                <Select value={form.area} onValueChange={(v) => setForm(f => ({ ...f, area: v }))}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="legislativo">Legislativo</SelectItem>
                    <SelectItem value="licitacoes">Licitações</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div><Label>Categoria</Label><Input value={form.category} onChange={(e) => setForm(f => ({ ...f, category: e.target.value }))} placeholder="Ex: Lei 14.133" /></div>
              <div><Label>Professor</Label><Input value={form.professor} onChange={(e) => setForm(f => ({ ...f, professor: e.target.value }))} /></div>
              <div><Label>Duração (min)</Label><Input type="number" value={form.duration_minutes} onChange={(e) => setForm(f => ({ ...f, duration_minutes: e.target.value }))} /></div>
            </div>
            <div><Label>URL do vídeo (YouTube/Vimeo embed)</Label><Input required value={form.video_url} onChange={(e) => setForm(f => ({ ...f, video_url: e.target.value }))} placeholder="https://www.youtube.com/embed/…" /></div>
            <div><Label>URL da thumbnail</Label><Input value={form.thumbnail_url} onChange={(e) => setForm(f => ({ ...f, thumbnail_url: e.target.value }))} placeholder="https://…" /></div>
            <div className="flex items-center gap-2">
              <Switch checked={form.is_published} onCheckedChange={(v) => setForm(f => ({ ...f, is_published: v }))} />
              <Label>Publicado</Label>
            </div>
            <Button type="submit" className="w-full">{editId ? "Salvar" : "Cadastrar"}</Button>
          </form>
        </DialogContent>
      </Dialog>
    </AdminLayout>
  );
}
